import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { POtpInputComponent } from './p-otp-input.component';

@NgModule({
    imports: [CommonModule],
    declarations: [POtpInputComponent],
    exports: [POtpInputComponent]
})
export class POtpInputModule {}
